import { divIcon } from 'leaflet';
import { Marker } from 'react-leaflet';
import type { MapCurrentLocationCoordinates } from './useMapCurrentLocation';

type Props = {
  coordinates: MapCurrentLocationCoordinates;
};

export const LeafletCurrentLocationMarker = ({ coordinates }: Props) => {
  if (!coordinates) {
    return null;
  }

  const center: [number, number] = [coordinates.latitude, coordinates.longitude];

  return <Marker position={center} icon={currentLocationIcon} interactive={false} />;
};

// Use a divIcon instead of CircleMarker because CircleMarker can visually lag/stretch during Leaflet zoom animations.
const currentLocationIcon = divIcon({
  className: '',
  iconSize: [28, 28],
  iconAnchor: [14, 14],
  html: `
      <div
        style="
          width: 28px;
          height: 28px;
          border-radius: 9999px;
          background: rgba(59, 130, 246, 0.18);
          display: flex;
          align-items: center;
          justify-content: center;
          pointer-events: none;
        "
      >
        <div
          style="
            width: 12px;
            height: 12px;
            border-radius: 9999px;
            background: #3b82f6;
            border: 3px solid #ffffff;
            box-sizing: border-box;
          "
        ></div>
      </div>
    `
});
